import { Listbox, ListboxSection, ListboxItem } from '@nextui-org/react';
import { Link } from '@nextui-org/react';
import { ReactComponent as ApiTokensIcon } from '../../icons/api_tokens.svg';
import { ReactComponent as OrgIcon } from '../../icons/envs.svg';
import { ReactComponent as BehaviorsIcon } from '../../icons/behaviors.svg';
import { ReactComponent as SecretsIcon } from '../../icons/secrets.svg';
import { ReactComponent as EnvIcon } from '../../icons/tests.svg';
import Breadcrumbs from '../Breadcrumbs';

function SettingsPage() {
  const breadcrumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: window.location.href, breadcrumb: 'Settings' }
  ];
  return (
    <div className='bg-white pt-8 pb-8 pr-8 pl-4 space-y-8 w-full'>
      <div className='pl-4'>
        <Breadcrumbs crumbs={breadcrumbs} />
      </div>
      <div className='col-span-2 grid grid-cols-1 gap-4 pl-4'>
        <h1 className='col-span-4 text-2xl font-bold'>Settings:</h1>
      </div>
      <div className='flex text-2xl justify-center items-center' style={{marginTop: 0}}>
        <Listbox className='h-full' variant='light'>
          <ListboxSection>
            <ListboxItem>
              <Link href='/settings/api_tokens' className='hover:bg-gray-300 p-2 rounded w-full text-black'>
                <ApiTokensIcon className='h-6 w-6 text-gray-700' />
                <span className='ml-2 text-lg'>API Tokens</span>
              </Link>
            </ListboxItem>
            <ListboxItem>
              <Link href='/settings/envs' className='hover:bg-gray-300 p-2 rounded w-full text-black'>
                <EnvIcon className='h-6 w-6 text-gray-700' />
                <span className='ml-2 text-lg'>Environments</span>
              </Link>
            </ListboxItem>
            <ListboxItem>
              <Link href='/settings/organizations' className='hover:bg-gray-300 p-2 rounded w-full text-black'>
                <OrgIcon className='h-6 w-6 text-gray-700' />
                <span className='ml-2 text-lg'>Organizations</span>
              </Link>
            </ListboxItem>
            <ListboxItem>
              <Link href='/settings/provider_secrets' className='hover:bg-gray-300 p-2 rounded w-full text-black'>
                <SecretsIcon className='h-6 w-6 text-gray-700' />
                <span className='ml-2 text-lg'>Secrets</span>
              </Link>
            </ListboxItem>
          </ListboxSection>
        </Listbox>
      </div>
    </div>
  );
}

export default SettingsPage;
